import { render, staticRenderFns } from "./waterStatistics-jinchu.vue?vue&type=template&id=0ad1b45a&"
import script from "./waterStatistics-jinchu.vue?vue&type=script&lang=js&"
export * from "./waterStatistics-jinchu.vue?vue&type=script&lang=js&"
import style0 from "./waterStatistics-jinchu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports